export function numberFormatter(value: number): string {
  const lookup = [
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'K' },
    { value: 1, symbol: '' },
  ];

  const positiveValue = value < 0 ? value * -1 : value;

  const item = lookup.find((item) => positiveValue >= item.value);

  if (item) {
    const formattedValue = (positiveValue / item.value).toFixed(0);
    const formattedValueWithComma = formattedValue.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ',',
    );
    return value < 0
      ? `- $${formattedValueWithComma}${item.symbol}`
      : `$${formattedValueWithComma}${item.symbol}`;
  }

  return value !== 0 ? `$${value}` : '$0';
}

export function decimalNumberFormatter(value: number): string {
  const parsedValue = Number(value?.toString());

  if (typeof parsedValue !== 'number') {
    throw new Error('Input must be a number');
  }

  // Convert the value to millions
  const millionValue = value / 1_000_000;

  // Format the number with one decimal place
  return `${millionValue < 0 ? '-' : ''}$${Math.abs(millionValue).toFixed(1)}M`;
}

export function numberShortFormatter(value: number): string {
  const lookup = [
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'K' },
    { value: 1, symbol: '' },
  ];

  const positiveValue = value < 0 ? value * -1 : value;

  const item = lookup.find((item) => positiveValue >= item.value);

  if (item) {
    const formattedValue = (positiveValue / item.value).toFixed(0);
    const formattedValueWithComma = formattedValue.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ',',
    );
    return value < 0
      ? `- $${formattedValueWithComma}${item.symbol}`
      : `$${formattedValueWithComma}${item.symbol}`;
  }

  return value !== 0 ? `$${value}` : '$0';
}
